import { useCallback } from 'react';

import { ConditionsReactivateVideoTutorielDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import { useChangeValidityVideoTutorielReturn } from './type';

export function useChangeValidityVideoTutoriel(): useChangeValidityVideoTutorielReturn {
  const controller = useApi().AdminFonctionnelControllerApi;

  const submitDeprecateVideo = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.deprecateVideoTutorielUsingPUT(idCorrelation);
    },
    [controller],
  );

  const submitReactivateVideo = useCallback(
    (idCorrelation: string): Promise<Response> => {
      return controller.reactivateVideoTutorielUsingPUT(idCorrelation);
    },
    [controller],
  );

  const conditionsReactivateVideo = useCallback(
    (idCorrelation: string): Promise<ConditionsReactivateVideoTutorielDto> => {
      return controller.conditionReactivationVideoTutorielUsingGET(
        idCorrelation,
      );
    },
    [controller],
  );

  return {
    submitReactivateVideo,
    submitDeprecateVideo,
    conditionsReactivateVideo,
  };
}
